// Google Consent Mode v2 helper
// Defaults are set in index.html BEFORE any Google script loads.

const STORAGE_KEY = "zantravika_consent_v1";

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
  personalization: false,
};

export function loadConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") return { ...DEFAULT_CONSENT, ...parsed };
    return null;
  } catch (e) {
    return null;
  }
}

export function saveConsent(consent) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...consent, ts: Date.now() })
    );
  } catch (e) {
    // ignore
  }
}

export function clearConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // ignore
  }
}

function pushGtag(...args) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

export function updateConsent(consent) {
  const payload = {
    ad_storage: consent.marketing ? "granted" : "denied",
    ad_user_data: consent.marketing ? "granted" : "denied",
    ad_personalization: consent.marketing ? "granted" : "denied",
    analytics_storage: consent.analytics ? "granted" : "denied",
    functionality_storage: "granted",
    personalization_storage: consent.personalization ? "granted" : "denied",
    security_storage: "granted",
  };

  pushGtag("consent", "update", payload);

  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "cookie_consent_update", consent: payload });
  }
}

export function applyStoredConsent() {
  const stored = loadConsent();
  if (stored) {
    updateConsent(stored);
    return stored;
  }
  return null;
}

export function acceptAll() {
  const c = { necessary: true, analytics: true, marketing: true, personalization: true };
  saveConsent(c);
  updateConsent(c);
  return c;
}

export function rejectAll() {
  const c = { necessary: true, analytics: false, marketing: false, personalization: false };
  saveConsent(c);
  updateConsent(c);
  return c;
}
